import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../Homepage/Navbar';
import Footer from '../Homepage/Footer';
import { Base_URL, imageBaseURL } from '../../actions/API_endpoint';

const GalleryList = () => {
    const [galleries, setGalleries] = useState([]);

    useEffect(() => {
        const fetchGalleries = async () => {
            try {
                const response = await axios.get(`${Base_URL}/api/galleries`);
                if (response.data.success) {
                    setGalleries(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching galleries:", error);
            }
        };
        fetchGalleries();
    }, []);

    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-grow pt-32 pb-20 bg-dark-secondary">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-center text-white mb-16">
                        NVCTI <span className="text-nvcti-orange">Gallery</span>
                    </h1>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                        {galleries.length > 0 ? (
                            galleries.map((gallery) => (
                                <Link to={`/gallery/${gallery.id}`} key={gallery.id} className="block group h-full">
                                    <div className="bg-dark-tertiary rounded-2xl shadow-xl overflow-hidden hover:shadow-accent-primary/20 transition-all duration-300 h-full border border-white/5 flex flex-col relative">
                                        <div className="h-64 bg-white/5 w-full flex items-center justify-center text-gray-500 group-hover:bg-white/10 transition-colors overflow-hidden relative">
                                            {gallery.images && gallery.images.length > 0 ? (
                                                <img
                                                    src={`${imageBaseURL}${gallery.images[0].image_path}`}
                                                    alt={gallery.name}
                                                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                                />
                                            ) : (
                                                <i className="fas fa-images text-5xl"></i>
                                            )}
                                            <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-all duration-300"></div>
                                        </div>
                                        <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/90 to-transparent">
                                            <h2 className="text-2xl font-bold text-white mb-1 group-hover:text-nvcti-orange transition-colors">
                                                {gallery.name}
                                            </h2>
                                            <p className="text-gray-300 text-sm">
                                                {gallery.images ? gallery.images.length : 0} Photos
                                            </p>
                                        </div>
                                    </div>
                                </Link>
                            ))
                        ) : (
                            <div className="col-span-full text-center text-gray-400 text-xl">
                                No galleries found.
                            </div>
                        )}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GalleryList;
